(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("d3"), require("ProtvistaZoomable"));
	else if(typeof define === 'function' && define.amd)
		define(["d3", "ProtvistaZoomable"], factory);
	else if(typeof exports === 'object')
		exports["ProtvistaSequence"] = factory(require("d3"), require("ProtvistaZoomable"));
	else
		root["ProtvistaSequence"] = factory(root["d3"], root["ProtvistaZoomable"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 